import React, { Component } from 'react'
import Header from '../Header'
import './XIIIw.css'

class XIIIw extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div className="bodyXIIIw">
                    <p className="textXIIIw">A venir...</p>
                </div>
            </div>
        )
    }
}

export default XIIIw